import { render, staticRenderFns } from "./ListTarifSpecifique.vue?vue&type=template&id=2727ad55&scoped=true"
import script from "./ListTarifSpecifique.vue?vue&type=script&lang=js"
export * from "./ListTarifSpecifique.vue?vue&type=script&lang=js"
import style0 from "./ListTarifSpecifique.vue?vue&type=style&index=0&id=2727ad55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727ad55",
  null
  
)

export default component.exports